import { FC, useState } from "react";
import { useAuthContext } from "providers/Auth";
import PlaidIcon from "shared/icons/plaidIcon.svg?react";
import { Modal } from "shared/components";
import {
  Button,
  ButtonSize,
  ButtonVariant,
  IconButton
} from "shared/components";
import { Bank, XClose } from "untitledui-js-base";

import { BankAccount } from "types/billing";
import { ManualEntryForm } from "./ACHForm";

interface ChangeBankAccountModalProps {
  isOpen: boolean;
  onDismiss: () => void;
  onSubmit: (updates: BankAccount) => void;
  bankAccountRequired?: boolean;
}

export const ChangeBankAccountModal: FC<ChangeBankAccountModalProps> = ({
  isOpen,
  onDismiss,
  onSubmit,
  bankAccountRequired
}) => {
  const [manualEntry, setManualEntry] = useState(Boolean(bankAccountRequired));
  const { dashboard } = useAuthContext();

  return (
    <Modal
      opened={isOpen}
      onClose={onDismiss}
      panelClassName="relative mx-auto max-w-[420px] w-full rounded-lg shadow-xl h-[598px] flex flex-col justify-between"
    >
      {manualEntry ? (
        <ManualEntryForm onSubmitBankAccount={onSubmit} onDismiss={onDismiss} />
      ) : (
        <>
          <div className="p-6 text-center relative">
            <div className="absolute right-4 top-4">
              <IconButton onClick={onDismiss} Icon={XClose} borderLess />
            </div>
            <div className="mx-auto mb-6 flex size-[100px] items-center justify-center rounded-full bg-primary-20">
              <Bank className="size-10 stroke-primary-500" strokeWidth={1} />
            </div>
            <h3 className="text-xl font-semibold text-content-1000">
              Change bank account
            </h3>
            <p className="mt-2 text-sm text-content-400">
              Please connect the bank account
            </p>
          </div>

          <div className="p-6">
            <div className="flex flex-col gap-4">
              <a
                href={dashboard?.billing.plaid_link}
                target="_blank"
                rel="noreferrer"
                className="block w-full"
              >
                <Button
                  size={ButtonSize.BASE}
                  variant={ButtonVariant.PRIMARY}
                  className="!stroke-none w-full"
                  Icon={PlaidIcon}
                >
                  Connect with Plaid instantly
                </Button>
              </a>
              <Button
                size={ButtonSize.BASE}
                variant={ButtonVariant.BASE}
                className="w-full"
                onClick={() => setManualEntry(true)}
              >
                Connect bank account manually
              </Button>
            </div>
          </div>
        </>
      )}
    </Modal>
  );
};
